import { z } from 'zod';
import { transformAndFilterValidEdges } from '../../../common/tools/transformEdgesUtils';
import { MENU_ITEMS_SOURCES } from '../types/NavigationNode';

// Pimcore's NavigationNode
export const NavigationNodeSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        index: z.number(), // 0-based index among siblings
        fullpath: z.string(),
        name: z.string(),
        route: z.string().nullable(),
        parentNode: z.object({
            id: z.string(),
        }),
        // GlobalMEnuItem brick
        isGlobalMenuItem: z
            .boolean()
            .nullable()
            .transform((v) => v ?? false),
        additionalMenuItemsSource: z
            // before parsing, turn the empty‐string into a real null
            .preprocess((val) => (val === '' ? null : val), z.enum(MENU_ITEMS_SOURCES).nullable()),
    })
    .describe('NavigationNodeSchema');

// Main schema to validate the entire query response
export const GetNavigationNodeListingSchema = z
    .object({
        getNavigationNodeListing: z.object({
            edges: z
                .array(
                    z.object({
                        node: z.unknown(),
                    })
                )
                .transform((edges) => transformAndFilterValidEdges(NavigationNodeSchema, edges)),
        }),
    })
    .describe('GetNavigationNodeListingSchema');
